import React from "react";
import classnames from "classnames";
import { PlusIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import {
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setIsHistoryModalOpened,
    setIsPlusIconClicked,
    setIsResetAllLogos,
    store,
    setIsLoading,
    setDataIsUpdated,
} from "../store";
import { store as useStore } from "@components/VerticalLayout/store";

import ErrorToast from "../../../../components/Common/ErrorTost";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import {
    archiveLogoFranchise,
    handleActiveLogo,
    handleArchiveLogo,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

export function CustomSideFilter({
    setLogo,
    setShopId,
    selectedRows,
    logo,
    setLocalFilterActive,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    isAddLogoClicked,
    setIsAddLogoClicked,
    isLogoArchived,
    setIsLogoArchived,
    setIsInInitializationModalOpened,
    data,
}: any) {
    const { t } = useTranslation();
    const { shopID, oneShop, userID, franchiseID, operatorID } = useSnapshot(
        useStore
    );
    const {
        numberArchived,
        numberActive,
        isHistoryModalOpened,
        shopsLogoData,
        isEdited,
        isActionsClicked,
        modify,
        isLoading,
        logoData,
    } = useSnapshot(store);
    const { fetchGlobal } = useFetchGlobal();
    const uuidUser = localStorage.getItem("uuidUser");

    function logoExistInShops() {
        let isIdExist;
        let idsAssociated: any = [];
        shopsLogoData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        });

        selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.Id)) {
                isIdExist = true;
            }
        });
        if (isIdExist === true && !oneShop) {
            ErrorToast(
                `${t(
                    "Please note that you cannot archive an item assigned to stores."
                )!}`
            );
            setIsLoading(false);
        } else {
            handleArchiveLogo(
                selectedRows,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                fetchGlobal
            );
        }
    }
    function logoExistInShopsActived() {
        let isIdExist;
        let idsAssociated: any = [];
        shopsLogoData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        });

        selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.Id)) {
                isIdExist = true;
            }
        });
        if (isIdExist === true && !oneShop) {
            setIsLoading(false);
            setIsModalConfirmationOpened(!isModalConfirmationOpened);
        } else {
            handleActiveLogo(
                selectedRows,
                userID,
                franchiseID,
                operatorID,
                uuidUser,
                fetchGlobal
            );
        }
    }
    function ArchivedLogo() {
        let idsAssociated: any[] = [];
        if (logoData !== undefined) {
            logoData.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    let dataArchive: any[] = [];
    if (!oneShop) {
        dataArchive = ArchivedLogo();
    } else {
        dataArchive = archiveLogoFranchise(data);
    }

    async function isSaleSupportArchived() {
        let isSaleSupportArchived = false;
        try {
            const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&franchiseId=${franchiseID}&type=archived&uuidUser=${uuidUser}`;

            const data: any = await fetchGlobal(url);
            data.data.forEach((elt: any) => {
                selectedRows.forEach((element: any) => {
                    element[t("Sales support")]
                        .split(",")
                        .forEach((support: any) => {
                            if (
                                elt.subRows.some(
                                    (sale: any) =>
                                        `${sale[t("Sale support")]} ${
                                            sale.shopId
                                        }` === `${support} ${element.shopId}`
                                )
                            ) {
                                isSaleSupportArchived = true;
                            }
                        });
                });
            });
        } catch (error) {
            throw error;
        }
        return isSaleSupportArchived;
    }

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {isAddLogoClicked !== true && modify === true ? (
                <span
                    onClick={() => {
                        setLogo([]);
                        setIsAddLogoClicked(!isAddLogoClicked);
                        setShopId(oneShop ? shopID : 0);
                        setLocalFilterActive(false);
                        setIsResetAllLogos(false);
                    }}
                    className={
                        isLogoArchived
                            ? "w-100 ml-2 not-allowed-icon__clz cmn_btn_openForm"
                            : "w-100 ml-2 cmn_btn_openForm"
                    }
                >
                    <CustomMainColorButtonWithIcon
                        icon="PlusIcon"
                        iconPosition="left"
                        rounded
                        variant="primary"
                    >
                        {t("Add a logo")}
                    </CustomMainColorButtonWithIcon>
                </span>
            ) : modify === true ? (
                <CustomMainColorIconButton
                    icon="PlusIcon"
                    className="lgo_btn_FRreset"
                    rounded
                    disabled={logo.length === 0 ? false : true}
                    onClick={() => {
                        if (isEdited === true)
                            setIsInInitializationModalOpened(true);
                        else {
                            setIsPlusIconClicked(true);
                        }
                    }}
                >
                    <PlusIcon height={20} width={20} fill="white" />
                </CustomMainColorIconButton>
            ) : null}

            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_FRmenu"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistActivated"
                    )}
                    onClick={() => {
                        setIsLogoArchived(false);
                        setDataIsUpdated(true);
                        setIsAddLogoClicked(false);
                    }}
                >
                    {t("Enabled logo(s)")} ({numberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistArchived"
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                setIsLogoArchived(true);
                                setDataIsUpdated(true);
                                setIsAddLogoClicked(false);
                            });
                        } else {
                            setIsLogoArchived(true);
                            setDataIsUpdated(true);
                            setIsAddLogoClicked(false);
                        }
                    }}
                >
                    {t("Archived logo(s)")} ({numberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item pl-1 cmn_btn_FRhistory",
                        {
                            "not-allowed-icon__clz":
                                selectedRows.length === 0 || isLoading,
                        }
                    )}`}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                if (selectedRows.length === 1) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                } else {
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                                }
                            });
                        } else {
                            if (selectedRows.length === 1) {
                                ErrorToast(
                                    `${t(
                                        "Attention, it is a multiple action. Please select at least two items"
                                    )!}`
                                );
                            } else {
                                setIsHistoryModalOpened(!isHistoryModalOpened);
                            }
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true && (
                    <div
                        style={{ cursor: "pointer" }}
                        className={`${classnames(
                            "dropdown-item pl-1 cmn_btn_FRunarchive cmn_btn_FRarchived",
                            {
                                "not-allowed-icon__clz":
                                    isLoading ||
                                    selectedRows.length === 0 ||
                                    (selectedRows.length > 1 &&
                                        isLogoArchived &&
                                        oneShop &&
                                        selectedRows.some((element: any) =>
                                            dataArchive.includes(element.Id)
                                        )),
                            }
                        )}`}
                        onClick={async () => {
                            setIsLoading(true);
                            let isArchived = await isSaleSupportArchived();

                            if (isEdited === true) {
                                setIsLoading(false);
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    if (selectedRows.length === 1) {
                                        ErrorToast(
                                            `${t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )!}`
                                        );
                                    } else if (
                                        isArchived === true &&
                                        isLogoArchived
                                    ) {
                                        ErrorToast(
                                            `${t(
                                                "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                            )!}`
                                        );
                                    } else if (!isLogoArchived) {
                                        logoExistInShops();
                                    } else {
                                        logoExistInShopsActived();
                                    }
                                });
                            } else {
                                if (selectedRows.length === 1) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                    setIsLoading(false);
                                } else if (
                                    isArchived === true &&
                                    isLogoArchived
                                ) {
                                    ErrorToast(
                                        `${t(
                                            "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                        )!}`
                                    );
                                    setIsLoading(false);
                                } else if (!isLogoArchived) {
                                    logoExistInShops();
                                } else {
                                    logoExistInShopsActived();
                                }
                            }
                        }}
                    >
                        {isLogoArchived
                            ? `${t("Dearchive")}`
                            : `${t("Archive")}`}
                    </div>
                )}
            </div>
        </div>
    );
}
